<div class="scss-list">
    @if (isExpandable) {
        <mat-expansion-panel #header
            class="scss-list-expandable-container v3"
            hideToggle
            [expanded]="panelOpened"
            (opened)="SetPanelOpen(true)"
            (closed)="SetPanelOpen(false)">
            <mat-expansion-panel-header>
                <mat-panel-title class="align-items-start align-items-lg-center">
                    @if (listMode == ListMode.ExpandableMultiSelect) {
                        <lib-checkbox
                            #checkBox
                            class="scss-list-checkbox-padding"
                            [isIndeterminate]="isIndeterminate"
                            (change)="ToggleSelectAll($event)"
                            [qaTag]="qaTag ? qaTag + '-header-checkbox' : ''">
                        </lib-checkbox>
                    }
                    <div
                        class="d-flex flex-column flex-lg-row"
                        [ngClass]="{ 'ps-3': listMode != ListMode.ExpandableMultiSelect }">
                        <div class="d-flex align-items-center text-nowrap scss-list-title">
                            <ng-content select="[header]"></ng-content>
                        </div>
                        <div class="d-flex align-items-center scss-list-header-height">
                            <ng-content select="[labels]"></ng-content>
                        </div>
                    </div>
                </mat-panel-title>
                <mat-panel-description></mat-panel-description>
                <div class="d-flex position-absolute end-0 align-items-sm-center align-items-start scss-list-icon-container">
                    <div><ng-container *ngTemplateOutlet="rightMenu"></ng-container></div>

                    <lib-icon-button
                        [icon]="panelOpened ? Icon.Common.ExpandLess : Icon.Common.ExpandMore"
                        [kind]="ButtonKind.Neutral"
                        [size]="ButtonSize.Large"
                        (clicked)="header.toggle()">
                    </lib-icon-button>
                </div>
            </mat-expansion-panel-header>
            <ng-container *ngTemplateOutlet="listTemplate"></ng-container>
        </mat-expansion-panel>
    }

    @if (!isExpandable) {
        <div class="scss-list-container v3">
            <ng-container *ngTemplateOutlet="listTemplate"></ng-container>
        </div>
    }
</div>

<ng-template
    #listTemplate
    let-item>
    @if (isSelectable) {
        <mat-selection-list
            #selectionList
            [disableRipple]="true"
            (selectionChange)="SelectionChange()"
            [multiple]="listMode == ListMode.MultiSelect || listMode == ListMode.ExpandableMultiSelect">
            @for (item of items | orderByKey: 'inFooter'; track TrackItem($index, item)) {
                @if (!item.inFooter || footerExpanded) {
                    <mat-list-option
                        togglePosition="before"
                        [value]="item.value"
                        [disabled]="item.disabled"
                        [selected]="item.selected"
                        [attr.data-sb-qa]="qaTag ? qaTag + '-' + TrackItem($index, item) + '-selectable-option' : ''">
                        <ng-container *ngTemplateOutlet="rowContent; context: { $implicit: item }"></ng-container>
                    </mat-list-option>
                }
            }

        <ng-container *ngTemplateOutlet="footerItem"></ng-container>
        </mat-selection-list>
    }

    @if (!isSelectable) {
        <mat-list>
            @for (item of items | orderByKey: 'inFooter'; track TrackItem($index, item)) {
                @if (!item.inFooter || footerExpanded) {
                    <mat-list-item
                        [disabled]="item.disabled">
                        <ng-container *ngTemplateOutlet="rowContent; context: { $implicit: item }"></ng-container>
                    </mat-list-item>
                }
            }
            <ng-container *ngTemplateOutlet="footerItem"></ng-container>
        </mat-list>
    }
</ng-template>

<ng-template
    #rowContent
    let-item>
    @if (item.isExpandable) {
        <div class="d-flex justify-content-between">
            <div
                class="d-flex w-100 flex-wrap px-1"
                [ngClass]="{
                    'scss-list-item-closed': !item.expanded,
                    'scss-list-item-open': item.expanded,
                    'align-items-center': !item.isExpandable,
                    'align-items-start my-1': item.isExpandable,
                }">
                <ng-container *ngTemplateOutlet="item.content"></ng-container>
            </div>
            <lib-icon-button
                class="m-1"
                [icon]="item.expanded ? Icon.Common.ExpandLess : Icon.Common.ExpandMore"
                [kind]="ButtonKind.Tertiary"
                (clicked)="item.ExpandMore()"></lib-icon-button>
        </div>
    }
    @if (!item.isExpandable) {
        <ng-container *ngTemplateOutlet="item.content"></ng-container>
    }
</ng-template>

<ng-template #footerItem>
    @if (hasFooter) {
        <mat-list-item
            class="scss-list-footer-height">
            <div class="d-flex w-100 justify-content-center">
                <lib-button
                    [qaTag]="qaTag ? qaTag + '-footer-button' : ''"
                    [kind]="ButtonKind.Tertiary"
                    [prefixIcon]="footerExpanded ? Icon.Common.ExpandLess : Icon.Common.ExpandMore"
                    (clicked)="SetFooterOpen()">
                    <ng-container label>
                        <ng-content select="[footerText]"></ng-content>
                    </ng-container>
                </lib-button>
            </div>
        </mat-list-item>
    }
</ng-template>

<ng-template #rightMenu>
    <ng-content select="[rightMenu]"></ng-content>
</ng-template>